import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Restaumatic$dMenu$dPromotions from "../Restaumatic.Menu.Promotions/index.js";
import * as Restaumatic$dMenu$dQuery from "../Restaumatic.Menu.Query/index.js";
import * as Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion from "../Restaumatic.PromotionsEngine.Promotions.Types.Promotion/index.js";
const $PromotionInputOptions = (tag, _1) => ({tag, _1});
const FreeProductInputOptions = value0 => $PromotionInputOptions("FreeProductInputOptions", value0);
const CouponCodeInputOptions = /* #__PURE__ */ $PromotionInputOptions("CouponCodeInputOptions");
const NoInputOptions = /* #__PURE__ */ $PromotionInputOptions("NoInputOptions");
const newPromotionDetails = v => (
  {
    id: v.promotionId,
    name: v.name,
    description: v.description,
    inputOptions: (() => {
      if (v.prize.tag === "Freeby") { return $PromotionInputOptions("FreeProductInputOptions", {choices: Data$dFunctor.arrayMap(x => x.productName)(v.prize._1)}); }
      if (v.prize.tag === "CouponValue") { return CouponCodeInputOptions; }
      return NoInputOptions;
    })()
  }
);
const promotionDetails = id => Restaumatic$dMenu$dQuery.functorMenuQuery.map(newPromotionDetails)(Restaumatic$dMenu$dQuery.findPromotion(id));
const matchPaymentMethod = v => v1 => {
  if (v.tag === "Nothing") { return true; }
  if (v.tag === "Just") {
    const $0 = Data$dRecord.unsafeGet("groupId")(v1);
    return (() => {
      if ($0.tag === "Nothing") { return true; }
      if ($0.tag === "Just") { return false; }
      $runtime.fail();
    })() || v._1.tag === "PaymentMethodOnline";
  }
  $runtime.fail();
};
const matchFulfillmentMethod = v => v1 => {
  if (v.tag === "Nothing") { return true; }
  if (v.tag === "Just") {
    const v2 = Data$dRecord.unsafeGet("availableAt")(v1);
    if (v2.tag === "DeliveryOnly") { return v._1.tag === "Delivery"; }
    if (v2.tag === "TakeawayOnly") {
      if (v._1.tag === "Delivery") { return false; }
      return v._1.tag === "Takeaway";
    }
    if (v2.tag === "RestaurantOnly") {
      if (v._1.tag === "Delivery") { return false; }
      if (v._1.tag === "Takeaway") { return false; }
      return v._1.tag === "DineIn";
    }
    if (v2.tag === "DeliveryAndTakeaway") { return v._1.tag === "Delivery" || (v._1.tag === "Delivery" ? false : v._1.tag === "Takeaway"); }
    if (v2.tag === "RestaurantAndTakeaway") {
      return (() => {
        if (v._1.tag === "Delivery") { return false; }
        if (v._1.tag === "Takeaway") { return false; }
        return v._1.tag === "DineIn";
      })() || (v._1.tag === "Delivery" ? false : v._1.tag === "Takeaway");
    }
    if (v2.tag === "Everywhere") { return true; }
    $runtime.fail();
  }
  $runtime.fail();
};
const genericPromotionInputOptions = {
  to: x => {
    if (x.tag === "Inl") { return $PromotionInputOptions("FreeProductInputOptions", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return CouponCodeInputOptions; }
      if (x._1.tag === "Inr") { return NoInputOptions; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "FreeProductInputOptions") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "CouponCodeInputOptions") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "NoInputOptions") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments)); }
    $runtime.fail();
  }
};
const eqPromotionInputOptions = {
  eq: /* #__PURE__ */ (() => {
    const $0 = Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl);
    return x => y => {
      const $1 = genericPromotionInputOptions.from(x);
      const $2 = genericPromotionInputOptions.from(y);
      if ($1.tag === "Inl") {
        if ($2.tag === "Inl") { return $0($1._1.choices)($2._1.choices); }
        return false;
      }
      if ($1.tag === "Inr") {
        if ($2.tag === "Inr") {
          if ($1._1.tag === "Inl") { return $2._1.tag === "Inl"; }
          if ($1._1.tag === "Inr") { return $2._1.tag === "Inr"; }
          return false;
        }
        return false;
      }
      return false;
    };
  })()
};
const enginePromotions = menu => mFulfillmentMethod => mPaymentMethod => Data$dFunctor.arrayMap(Restaumatic$dMenu$dPromotions.toEnginePromotion)(Data$dArray.filter(matchFulfillmentMethod(mFulfillmentMethod))(Data$dArray.filter(matchPaymentMethod(mPaymentMethod))(Data$dArray.filter(x => !Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.eqPromotionConditions.eq(x.conditions)(Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.$PromotionConditions(
  "CartPromotion",
  Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.Loyalty
)))(Data$dArray.fromFoldableImpl(Data$dMap$dInternal.foldableMap.foldr)(menu.promotions)))));
export {
  $PromotionInputOptions,
  CouponCodeInputOptions,
  FreeProductInputOptions,
  NoInputOptions,
  enginePromotions,
  eqPromotionInputOptions,
  genericPromotionInputOptions,
  matchFulfillmentMethod,
  matchPaymentMethod,
  newPromotionDetails,
  promotionDetails
};
